import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/store/userStore";

// PAGES & LAYOUTS
import AuthPage from "@/pages/AuthPage";
import HelpPage from "@/pages/HelpPage";
import HomePage from "@/pages/HomePage";
import UserLayout from "@/layouts/UserLayout";
import LibraryPage from "@/pages/LibraryPage";
import ParentsSalon from "@/pages/ParentsSalon";
import CoursesPage from "@/pages/CoursesPage";
import AnnouncementsLayout from "@/layouts/AnnouncementsLayout";
import EventsPage from "@/pages/EventsPage";
import NewsPage from "@/pages/NewsPage";
import AdminPage from "@/pages/AdminPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ArticlePage from "@/pages/ArticlePage";
import PageNotFound from "@/pages/PageNotFound";
// import InstructorOverview from "@/pages/InstructorOverview";

// USER
import UserInfo from "@/components/UserInfo.vue";
import UserSettings from "@/components/UserSettings.vue";
import UserPasswordSettings from "@/components/UserPasswordSettings.vue";
import UserAvatarSettings from "@/components/UserAvatarSettings.vue";
import UserBioSettings from "@/components/UserBioSettings.vue";
import UserFavorites from "@/components/UserFavorites.vue";
import UserCourses from "@/components/UserCourses.vue";
import UserPanel from "@/components/UserPanel.vue";
import UserQuestionnaires from "@/components/UserQuestionnaires.vue";
import UserParentSalon from "@/components/UserParentSalon";
import ParentEventPlanning from "@/components/ParentEventPlanning";
import UserSalonList from "@/components/UserSalonList";
import PoliticPage from "@/pages/PoliticPage.vue";
import UserAgreePage from "@/pages/UserAgreePage.vue";

// ADMIN
import AdminItemShedule from "@/pages/AdminItemShedule";
import AdminUsersPaginated from "@/pages/AdminUsersPaginated.vue";
import AdminCourseShedule from "@/pages/AdminCourseShedule";
import AdminClients from "@/pages/AdminClients";
import AdminCoursePage from "@/pages/AdminCoursePage";
import AdminLibraryPage from "@/pages/AdminLibraryPage";
import AdminFaqPage from "@/pages/AdminFaqPage";
import AdminQuesPage from "@/pages/AdminQuesPage";
import AdminWebinarPage from "@/pages/AdminWebinarPage.vue";

// COURSE
import CourseLayout from "@/layouts/CourseLayout";
import CourseOverview from "@/pages/CourseOverview";
import CourseLessons from "@/pages/CourseLessons";
import CourseInstructor from "@/pages/CourseInstructor";

// WEBINAR
import WebinarLayout from "@/layouts/WebinarLayout";
import WebinarOverview from "@/pages/WebinarOverview";
import WebinarInstructor from "@/pages/WebinarInstructor";

// QUESTIONNAIRIES 
import QuestionnairesPage from "@/pages/QuestionnairesPage.vue";
import QuestionsPage from "@/pages/QuestionsPage";

import { storeToRefs } from "pinia";
import SalonOverview from "@/pages/SalonOverview.vue";
import AdminBookShelf from "@/pages/AdminBookShelf.vue";
import BookShelf from "@/pages/BookShelf.vue";
import UserDeactivateAccount from "@/components/UserDeactivateAccount.vue";
import AdminNewsPaginated from "@/pages/AdminNewsPaginated.vue";
import AdminNewsTags from "@/pages/AdminNewsTags.vue";
import AdminParentSalons from "@/pages/AdminParentSalons.vue";
import ArticlePagePaginated from "@/pages/ArticlePagePaginated.vue";
import ArticleOverview from "@/pages/ArticleOverview.vue";
import AdminLibraryVideo from "@/pages/AdminLibrary/adminLibraryVideo.vue";
import UserChatList from "@/components/UserChatList.vue";
import UserChat from "@/components/UserChat.vue";
import BotLayout from "@/layouts/BotLayout.vue";
import BotChatLayout from "@/layouts/BotChatLayout.vue";
import ExpertsPage from "@/pages/ExpertsPage.vue"

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: "/politic", component: PoliticPage },
    { path: "/useragree", component: UserAgreePage },
    { path: "/", component: HomePage },
    {
      path: "/admin",
      component: AdminPage,

      children: [
        { path: "clients", component: AdminClients },
        { path: "users", component: AdminUsersPaginated },
        { path: "course", component: AdminCoursePage },
        { path: "webinar", component: AdminWebinarPage },
        { path: "library", component: AdminLibraryPage },
        { path: "video", component: AdminLibraryVideo },
        { path: "faq", component: AdminFaqPage },
        { path: "news", component: AdminNewsPaginated },
        { path: "news_tag", component: AdminNewsTags },
        { path: "events", component: AdminParentSalons },
       // { path: "questionnaire", component: AdminQuesPage },
        { path: "book_shelf", component: AdminBookShelf },
      ],
    },
    {
      path: "/admin/courses/course/:id/shedule",
      component: AdminCourseShedule,
    },
    {
      path: "/admin/courses/course/:id/shedule/item/:item?",
      component: AdminItemShedule,
    },
    { path: "/questionnaire/:id?", component: QuestionsPage },

    { path: "/help", component: HelpPage },
    { path: "/book_shelf", component: BookShelf },
    { path: "/auth/:type?/:code?", component: AuthPage },
    {
      path: "/course/:id",
      component: CourseLayout,
      children: [
        { path: "overview", component: CourseOverview },
        { path: "reviews", component: ReviewsPage },
        { path: "lessons", component: CourseLessons },
        { path: "instructor", component: CourseInstructor },
      ],
    },
    {
      path: "/announcements",
      component: AnnouncementsLayout,
      children: [
        { path: "events", component: EventsPage },
        { path: "news", component: NewsPage },
      ],
    },
    {
      path: "/bot",
      component: BotLayout,
    },
    {
          path: "/experts",
          component: ExpertsPage,
        },
    {
      path: "/bot/:id",
      component: BotChatLayout,
    },
    {
      path: "/user",
      component: UserLayout,
      children: [
        { path: "account", component: UserInfo },
        { path: "bot", component: UserChatList},
        { path: "bot/:id", component: UserChat},
        {
          path: "settings",
          component: UserSettings,
          children: [
            { path: "name", component: UserBioSettings },
            { path: "avatar", component: UserAvatarSettings },
            { path: "password", component: UserPasswordSettings },
            { path: "deactivate", component: UserDeactivateAccount },
            
          ],
        },
        { path: "questionnaires", component: UserQuestionnaires },
        {
          path: "salon",
          component: UserParentSalon,
          children: [
            {
              path: "planning/:edit?",
              component: ParentEventPlanning,
            },
            {
              path: "list",
              component: UserSalonList,
            },
          ],
        },
        {
          path: "favorites",
          component: UserFavorites,
        },
        {
          path: "courses",
          component: UserCourses,
        },

        {
          path: "panel",
          component: UserPanel,
        },
      ],
    },
    {
      path: "/library",
      component: LibraryPage,
    },

    { path: "/library/article/:id", component: ArticlePage },

    { path: "/courses", component: CoursesPage },
    {
      path: "/webinar/:id",
      component: WebinarLayout,
      children: [
        { path: "overview", component: WebinarOverview },
        { path: "instructor", component: WebinarInstructor },
      ],
    },
    {
      path: "/salon",
      component: ParentsSalon,
    },
    {
      path: "/salon/:id",
      component: SalonOverview,
    },
    {
      path: "/article",
      component: ArticlePagePaginated,
    },
    {
      path: "/article/:id",
      component: ArticleOverview,
    },
   // { path: "/questionnaires", component: QuestionnairesPage },

    { path: "/:pathMatch(.*)*", component: PageNotFound },
  ],
  scrollBehavior() {
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
  },
});

router.beforeEach(async (to) => {
  const userStore = useUserStore();
  const { isAdmin } = storeToRefs(userStore);

  if (to.path.includes("/admin") && !isAdmin.value) {
    return {
      path: "/404",
      component: PageNotFound,
    };
  }
});

// router.beforeEach((to, from, next) => {
//   // redirect to login page if not logged in and trying to access a restricted page
//   //const publicPages = [ '/' ]
//   const publicPages = [ '/','/questionnaire_survey' ]
//   const authRequired = !publicPages.includes(to.path)
//   const loggedIn = localStorage.getItem('user')

//   if (authRequired && !loggedIn) {
//     return next('/')
//   }
//   next()
// })
